// extracted by mini-css-extract-plugin
export var subtitle = "_b1-2";
export var title = "_b1-0";
export var titleNoWrap = "_b1-1";